import styled from "styled-components";

import { adminTokens } from "@pages/AdminDashboard/theme/adminTokens";
import { CopyButton } from "@pages/AdminDashboard/ui/CopyButton";
import { UiKitSection } from "@pages/AdminDashboard/ui/UiKitSection";

const [spaceXs, , spaceMd, , spaceXl] = adminTokens.spacing;

const examples = [
  { name: "Beside an email", value: "test.traveler@example.com", what: "email" },
  { name: "Beside an order ID", value: "b72e0c4a-1111-4222-8333-444455556666", what: "order ID" },
];

const Grid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(min(320px, 100%), 1fr));
  gap: ${spaceMd}px;
  margin-bottom: ${spaceXl}px;
`;

const Example = styled.div.attrs({ role: "group" })`
  display: flex;
  flex-direction: column;
  gap: ${spaceXs}px;
  border: 1px solid ${adminTokens.color.border};
  border-radius: ${adminTokens.radius.row}px;
  padding: ${spaceMd}px;
`;

const Caption = styled.span`
  color: ${adminTokens.color.inkSoft};
  font-family: ${adminTokens.typeScale.meta.fontFamily};
  font-size: ${adminTokens.typeScale.meta.fontSize};
`;

const ValueRow = styled.span`
  display: inline-flex;
  align-items: center;
  gap: 2px;
  overflow-wrap: anywhere;
  font-family: ${adminTokens.typeScale.labelValue.fontFamily};
`;

// The copy Button beside the kinds of value it copies, each under its own label (ACCT-R21,
// UIKIT-R8).
export const CopyButtonSection = () => (
  <UiKitSection title="Copy">
    <Grid>
      {examples.map(({ name, value, what }) => (
        <Example key={name} aria-label={name}>
          <Caption>{name}</Caption>
          <ValueRow>
            {value}
            <CopyButton value={value} what={what} />
          </ValueRow>
        </Example>
      ))}
    </Grid>
  </UiKitSection>
);
